// src/slices/headerSlice.ts
import { createSlice } from '@reduxjs/toolkit';

interface HeaderState {
  shouldRefresh: boolean; // This flag will be used to trigger a refresh in the Header component
}

const initialState: HeaderState = {
  shouldRefresh: false, // Initial state of refresh flag is set to false
};

// Create the slice to handle header-related actions and state
const headerSlice = createSlice({
  name: 'header', // Name for the slice, typically the same as the feature
  initialState, // Initial state for the slice
  reducers: {
    // Action to set the refresh flag to true (trigger refresh)
    refreshHeaderData: (state) => {
      state.shouldRefresh = true;
    },
    
    // Action to reset the refresh flag to false (after refresh is done)
    resetHeaderRefresh: (state) => {
      state.shouldRefresh = false;
    },
  },
});

// Export the actions generated by the slice
export const { refreshHeaderData, resetHeaderRefresh } = headerSlice.actions;

// Export the reducer to be used in the store
export default headerSlice.reducer;
